import cacheLs from "../cacheLs"

export default {
  setMeshUrl (state, data) {
    state.meshurl = data
    cacheLs.set_mesh_url(data)
  }
}
